<template>
  <div id="app">
    <Sidebar v-if="!$route.path.includes('theadmin')"></Sidebar>
    <transition
      name="fade"
      mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<style lang="scss">
  @import '@/assets/scss/style.scss';

  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 1.2s;
    transition-property: opacity;
    transition-timing-function: cubic-bezier(0.785, 0.135, 0.15, 0.86);
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }

</style>

<script>
import Sidebar from '@/components/Sidebar'

export default {
  name: 'Home',
  components: {
    Sidebar
  }
}
</script>